
import { useState, useEffect, useCallback } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';

const STATUS_LABEL = {
  TIMED:'Upcoming', SCHEDULED:'Upcoming', IN_PLAY:'LIVE', PAUSED:'HT', FINISHED:'FT',
};
const STATUS_COL = {
  IN_PLAY:'#22c55e', PAUSED:'#f5c518', FINISHED:'#8ba3cc', TIMED:'#38bdf8', SCHEDULED:'#38bdf8'
};

function MatchCard({ m, onSelect, selected }) {
  const ko = new Date(m.utcDate);
  const live = m.status === 'IN_PLAY' || m.status === 'PAUSED';
  const fin  = m.status === 'FINISHED';
  return (
    <div onClick={() => !fin && onSelect(m)}
      style={{
        background: selected ? '#0a1e38' : '#0f1e38',
        border: `2px solid ${selected ? '#38bdf8' : (live ? '#22c55e' : '#1e3a6e')}`,
        borderRadius:12, padding:'14px 16px', cursor: fin ? 'default' : 'pointer',
        transition:'border-color 0.15s', opacity: fin ? 0.55 : 1
      }}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:8}}>
        <span style={{fontSize:'0.55rem',letterSpacing:'0.15em',color:'#8ba3cc',textTransform:'uppercase'}}>{m.competition}</span>
        <span style={{fontSize:'0.62rem',fontWeight:700,color: STATUS_COL[m.status]||'#8ba3cc',
          ...(live ? {animation:'pulse 1.5s ease infinite'} : {})
        }}>{live ? '● LIVE' : STATUS_LABEL[m.status]||m.status}</span>
      </div>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:8}}>
        <span style={{flex:1,fontSize:'0.88rem',fontWeight:700,color:'#e8edf8',textAlign:'right'}}>{m.homeShort}</span>
        <span style={{fontSize:'0.75rem',fontFamily:"'Bebas Neue',sans-serif",color:'#f5c518',
          background:'#0a1628',border:'1px solid #1e3a6e',borderRadius:6,padding:'3px 10px',minWidth:52,textAlign:'center'}}>
          {live||fin ? `${m.homeScore??0} – ${m.awayScore??0}` : ko.toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'})}
        </span>
        <span style={{flex:1,fontSize:'0.88rem',fontWeight:700,color:'#e8edf8'}}>{m.awayShort}</span>
      </div>
      {m.stage&&<div style={{fontSize:'0.55rem',color:'#4a6a9e',marginTop:5,textAlign:'center'}}>{m.stage}</div>}
    </div>
  );
}

export default function LiveMatches({ onBack, onStartPredictor }) {
  const [matches,setMatches]   = useState([]);
  const [loading,setLoading]   = useState(true);
  const [selected,setSelected] = useState(null);
  const [error,setError]       = useState('');

  const onMsg = useCallback((msg) => {
    if (msg.type === 'MATCHES_LIST') {
      setMatches(msg.matches || []);
      setLoading(false);
    }
  }, []);
  const { send } = useWebSocket(onMsg);
  useEffect(() => { send('PREDICTOR_GET_MATCHES'); }, [send]);

  

  const live    = matches.filter(m => m.status==='IN_PLAY'||m.status==='PAUSED');
  const upcoming= matches.filter(m => m.status==='TIMED'||m.status==='SCHEDULED');
  const finished= matches.filter(m => m.status==='FINISHED');

  return (
    <div className="layer" style={{display:'flex',flexDirection:'column',minHeight:'100vh'}}>
      <div className="g-hdr">
        <button className="g-back" onClick={onBack}>← Menu</button>
        <div className="g-title" style={{color:'#22c55e'}}>LIVE MATCHES</div>
        <div className="g-pills">
          <div className="g-pill g"><span className="g-plbl">Live</span><span className="g-pval">{live.length}</span></div>
          <div className="g-pill b"><span className="g-plbl">Up Next</span><span className="g-pval">{upcoming.length}</span></div>
        </div>
      </div>
      <div className="game-body" style={{maxWidth:640}}>
        {loading && <p style={{color:'#8ba3cc',textAlign:'center',fontSize:'0.8rem'}}>Fetching live matches...</p>}
        {!loading && matches.length === 0 && (
          <div style={{textAlign:'center',padding:32}}>
            <div style={{fontSize:'2rem',marginBottom:8}}>📅</div>
            <p style={{color:'#8ba3cc',fontSize:'0.84rem'}}>No matches in the next 24 hours</p>
            <p style={{color:'#4a6a9e',fontSize:'0.7rem',marginTop:6}}>Covering: World Cup · Euros · Premier League · Championship</p>
            {error&&<p style={{color:'#f87171',fontSize:'0.7rem',marginTop:8}}>{error}</p>}
          </div>
        )}

        {live.length > 0 && <>
          <div style={{fontSize:'0.55rem',letterSpacing:'0.2em',color:'#22c55e',textTransform:'uppercase',fontWeight:700}}>● Live Now</div>
          {live.map(m => <MatchCard key={m.id} m={m} selected={selected?.id===m.id} onSelect={setSelected}/>)}
        </>}

        {upcoming.length > 0 && <>
          <div style={{fontSize:'0.55rem',letterSpacing:'0.2em',color:'#38bdf8',textTransform:'uppercase',marginTop:8}}>Upcoming — Next 24h</div>
          {upcoming.map(m => <MatchCard key={m.id} m={m} selected={selected?.id===m.id} onSelect={setSelected}/>)}
        </>}

        {finished.length > 0 && <>
          <div style={{fontSize:'0.55rem',letterSpacing:'0.2em',color:'#4a6a9e',textTransform:'uppercase',marginTop:8}}>Recently Finished</div>
          {finished.map(m => <MatchCard key={m.id} m={m} selected={null} onSelect={()=>{}}/>)}
        </>}

        {selected && (
          <div style={{position:'sticky',bottom:12,display:'flex',gap:8,flexDirection:'column',
            background:'#080f1e',borderTop:'1px solid #1e3a6e',paddingTop:12}}>
            <div style={{fontSize:'0.72rem',color:'#e8edf8',textAlign:'center',fontWeight:600}}>
              Selected: <span style={{color:'#38bdf8'}}>{selected.homeShort} vs {selected.awayShort}</span>
            </div>
            <button className="btn-blue" onClick={() => onStartPredictor(selected)}>
              🎯 Create Predictor Session
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
